import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { ASSETS, COMPANY, SERVICES } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo + intro */}
          <div className="md:col-span-1">
            <div className="bg-white inline-flex p-2 rounded-xl mb-4">
              <img src={ASSETS.logo} alt="Rena Tjänster logotyp" className="h-14 w-auto rounded-md" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Rena Tjänster – professionell städning för företag, fastigheter och verksamheter i nordvästra Skåne.
            </p>
          </div>

          {/* Tjänster */}
          <div>
            <h2 className="text-white font-display font-semibold mb-4 text-base">Tjänster</h2>
            <ul className="space-y-2 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={s.path} className="hover:text-[#F59E0B]" data-testid={`footer-${s.slug}`}>
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Företag */}
          <div>
            <h2 className="text-white font-display font-semibold mb-4 text-base">Företag</h2>
            <ul className="space-y-2 text-sm">
              <li><Link to="/tjanster" className="hover:text-[#F59E0B]" data-testid="footer-tjanster">Alla tjänster</Link></li>
              <li><Link to="/om-oss" className="hover:text-[#F59E0B]" data-testid="footer-om-oss">Om företaget</Link></li>
              <li><Link to="/miljo-och-hallbarhet" className="hover:text-[#F59E0B]" data-testid="footer-miljo">Miljö & hållbarhet</Link></li>
              <li><Link to="/integritetspolicy" className="hover:text-[#F59E0B]" data-testid="footer-policy">Integritetspolicy</Link></li>
              <li><Link to="/kontakt" className="hover:text-[#F59E0B]" data-testid="footer-kontakt">Kontakt</Link></li>
              <li><Link to="/kontakt#offertformular" className="hover:text-[#F59E0B]" data-testid="footer-offert">Begär offert</Link></li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h2 className="text-white font-display font-semibold mb-4 text-base">Kontakt</h2>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 text-[#F59E0B] mt-0.5 flex-shrink-0" />
                <span data-testid="footer-address">{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 text-[#F59E0B] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#F59E0B]" data-testid="footer-email">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="h-4 w-4 text-[#F59E0B] mt-0.5 flex-shrink-0" />
                <a href={COMPANY.phoneLink} className="hover:text-[#F59E0B]" data-testid="footer-phone">{COMPANY.phone}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p data-testid="footer-credit">
            Hemsida skapad av{" "}
            <a
              href="https://elido.nu"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-[#F59E0B] transition-colors"
            >
              Elido
            </a>
          </p>
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {COMPANY.name}. Alla rättigheter reserverade.</p>
        </div>
      </div>
    </footer>
  );
}
